import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { TerminateWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('Terminate')
export class TerminateNode extends BaseWorkflowNode<TerminateWorkflowNode> {
  getColumnReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [];
  }

  getTagReferences(_schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [];
  }

  getParamReferences(
    _schemas: Map<string | symbol, BaseSchema>,
    _connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [];
  }

  getNamedInputReferences(
    _schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [];
  }
}
